/*
 * サブシステム名：OTM受付一覧編集
 * 機能名：受付一覧編集
 */
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import jaLocale from '@fullcalendar/core/locales/ja'

import flowMixin from '@/mixins/flowMixins'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

// import { mapGetters } from 'vuex'
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
const DdDateBox = () => import('@/components/DdDateBox')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'OtmScheduler',
  mixins: [flowMixin],
  components: {
    FullCalendar,
    DdCustomButton,
    DdTransparentButton,
    DdDateBox,
    DdTextBox,
    DdTimeBox
  },
  data: () => ({
    // FULL-CALENDAR
    calendarOptions: {
      locale: jaLocale, // ロケールを日本語に設定
      contentHeight: 'auto',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek,timeGridDay'
      },
      slotLabelFormat: [
        { hour: '2-digit', minute: '2-digit', meridiem: false, hour12: false } // 00:00, 01:00, ...
      ],
      eventTimeFormat: { // 時間フォーマットの指定
        hour: 'numeric',
        minute: '2-digit',
        hour12: false, // 24時間形式を指定
        meridiem: false // AM/PM を非表示
      },
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      initialView: 'dayGridWeek',
      weekends: false,
      editable: true, // ドラッグ＆ドロップを有効化
      // ダミー
      events: []
    },

    // 表示制御用
    showWeekEnd: true,
    dayMaxEventRows: null,

    // イベント管理用
    event: {},
    events: [],
    eventFilter: null,
    showEventDialog: false,

    // 制御用
    modeKengen: 0
  }),
  watch: {
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'users/helpUseFlg'
    })
  },
  created () {
  },
  mounted () {
    this.initSettings()
    this.initialize()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('OtmDeliveryLedger.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('OtmDeliveryLedger.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('OtmDeliveryLedger.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    initSettings: function () {
      this.dayMaxEventRows = null
      this.events = [
        { title: '予定①01', start: '2025-01-11', className: 'yellow-event' },
        { title: '予定①02', start: '2025-01-11', color: this.getEventColor('meeting') },
        { title: '予定①03', start: '2025-01-11', color: this.getEventColor('private') },
        { title: '予定①04', start: '2025-01-11' },
        { title: '予定①05', start: '2025-01-11' },
        { title: '予定①06', start: '2025-01-11' },
        { title: '予定①07', start: '2025-01-11' },
        { title: '予定①08', start: '2025-01-11' },
        { title: '予定①09', start: '2025-01-11' },
        { title: '予定①10', start: '2025-01-11' },
        { title: '予定①11', start: '2025-01-11' },
        { title: '予定①12', start: '2025-01-11' },
        { title: '予定①13', start: '2025-01-11' },
        { title: '予定①14', start: '2025-01-11' },
        { title: '予定①15', start: '2025-01-11' },
        { title: '予定①16', start: '2025-01-11' },
        { title: '予定①17', start: '2025-01-11' },
        { title: '予定①18', start: '2025-01-11' },
        { title: '予定①19', start: '2025-01-11' },
        { title: '予定①20', start: '2025-01-11' },
        { title: '予定①21', start: '2025-01-11' },
        { title: '予定①22', start: '2025-01-11' },
        { title: '予定①23', start: '2025-01-11' },
        { title: '予定①24', start: '2025-01-11' },
        { title: '予定①25', start: '2025-01-11' },
        //
        { title: '【比嘉】OTM工場→法人課 ピクシスエポック0050635 シルバー', start: '2025-01-29T09:00:00', end: '2025-01-29T11:00:00', className: 'orange-event custom-set' },
        { title: '【比嘉】OTM工場→法人課 ピクシスエポック0050645 シルバー', start: '2025-01-29T09:00:00', end: '2025-01-29T11:00:00', className: 'orange-event custom-set' },
        { title: '【比嘉】OTM工場→コザ シエンタＧＡＳ 1053373 シルバー', start: '2025-01-29T09:00:00', end: '2025-01-29T13:00:00', className: 'orange-event custom-set' },
        { title: '【比嘉】OTM工場→コザ カロ―ラクロス（カ）1046898 白', start: '2025-01-29T09:00:00', end: '2025-01-29T13:30:00', className: 'orange-event custom-set' },
        { title: '【又吉】OTM工場→読谷 ライズHEV 0063375 ブルー', start: '2025-01-29T11:30:00', end: '2025-01-29T13:00:00', className: 'yellow-event custom-set' },
        { title: '【又吉】読谷→糸満ヤード ハイエースV 2009973', start: '2025-01-29T13:00:00', end: '2025-01-29T15:00:00', className: 'yellow-event custom-set' },
        //
        { title: '【比嘉】OTM工場→法人課 ピクシスエポック0050635 シルバー', start: '2025-01-30T09:00:00', end: '2025-01-30T11:00:00', className: 'orange-event custom-set' },
        { title: '【比嘉】OTM工場→法人課 ピクシスエポック0050645 シルバー', start: '2025-01-30T09:00:00', end: '2025-01-30T11:00:00', className: 'orange-event custom-set' },
        { title: '【比嘉】OTM工場→コザ シエンタＧＡＳ 1053373 シルバー', start: '2025-01-30T09:00:00', end: '2025-01-30T13:00:00', className: 'orange-event custom-set' },
        { title: '【比嘉】OTM工場→コザ カロ―ラクロス（カ）1046898 白', start: '2025-01-30T09:00:00', end: '2025-01-30T13:30:00', className: 'orange-event custom-set', url: 'https://www.google.co.jp/maps/dir/%E3%80%92901-2122+%E6%B2%96%E7%B8%84%E7%9C%8C%E6%B5%A6%E6%B7%BB%E5%B8%82%E5%8B%A2%E7%90%86%E5%AE%A2%EF%BC%92%E4%B8%81%E7%9B%AE%EF%BC%91%EF%BC%93%E2%88%92%EF%BC%91+(%E6%A0%AA)+OTM+%E6%B5%A6%E6%B7%BB%E5%B7%A5%E5%A0%B4/%E6%B2%96%E7%B8%84%E7%9C%8C%E6%B2%96%E7%B8%84%E5%B8%82%E8%AB%B8%E8%A6%8B%E9%87%8C%EF%BC%92%E4%B8%81%E7%9B%AE%EF%BC%91%E2%88%92%EF%BC%91+%E3%82%B3%E3%82%B6%E9%81%8B%E5%8B%95%E5%85%AC%E5%9C%92/@26.2889928,127.7014126,13z/data=!3m1!4b1!4m13!4m12!1m5!1m1!1s0x34e56bb88dd87b35:0x1129be11755beae2!2m2!1d127.6951458!2d26.2441012!1m5!1m1!1s0x34e512402c99babb:0x8892a6b47ff763f0!2m2!1d127.7877984!2d26.3341962?hl=ja&entry=ttu&g_ep=EgoyMDI1MDEyNi4wIKXMDSoASAFQAw%3D%3D' },
        { title: '【又吉】OTM工場→読谷 ライズHEV 0063375 ブルー', start: '2025-01-30T11:30:00', end: '2025-01-30T13:00:00', className: 'yellow-event custom-set' },
        { title: '【又吉】読谷→糸満ヤード ハイエースV 2009973', start: '2025-01-30T13:00:00', end: '2025-01-30T15:00:00', className: 'yellow-event custom-set' },
        //
        { title: '比嘉 休暇', start: '2025-01-31', className: 'holiday custom-set' }
      ]
      this.calendarOptions = {
        ...this.calendarOptions,
        dayCellDidMount: this.addButtonToCell,
        weekends: this.showWeekEnd,
        dayMaxEvents: this.dayMaxEventRows, // 1日あたり最大2行のイベントを表示
        eventDrop: this.handleEventDrop, // イベントをドロップしたときの処理
        eventClick: this.handleEventClick, // イベントをクリックしたときの処理
        dateClick: this.handleDateClick,
        events: this.events
      }
    },

    // FOR FULL-CALENDAR
    addButtonToCell: function (arg) {
      if (arg.view.type === 'dayGridMonth' || arg.view.type === 'dayGridWeek') {
        const button = document.createElement('button')
        button.innerHTML = '<span class="material-icons event-add-icon">add</span>'
        // button.setAttribute('data-date', arg.date.toISOString().slice(0, 10))
        // button.style.position = 'absolute'
        // button.style.bottom = '5px'
        // button.style.right = '5px'
        // button.style.padding = '2px 5px'
        // button.style.fontSize = '0.8em'
        // button.style.cursor = 'pointer'
        button.classList.add('event-add-button')

        button.addEventListener('click', (event) => {
          // const date = event.target.getAttribute('data-date')
          const date = dayjs(arg.date).format('YYYY-MM-DD')
          this.showEventDialog = true
          this.createEvent(date)
        })

        arg.el.style.position = 'relative'
        arg.el.appendChild(button)
      }
    },
    addEvent: function (date) {
      alert(`Add event for ${date}`)
    },

    /**
     * 上部画面制御用
     */
    updateFilterdEventRows: function (val) {
      this.eventFilter = val
      this.calendarOptions = {
        ...this.calendarOptions,
        events: this.filteredEvents()
      }
    },
    updateShowWeekend: function (val) {
      this.showWeekEnd = val
      this.calendarOptions = {
        ...this.calendarOptions,
        weekends: val
      }
    },
    updateDayMaxEventRows: function (val) {
      this.dayMaxEventRows = val
      this.calendarOptions = {
        ...this.calendarOptions,
        dayMaxEvents: val
      }
    },

    getEventColor: function (eventType) {
      const colorMap = {
        important: 'red',
        meeting: 'aqua',
        private: 'lightgreen'
      }
      return colorMap[eventType] || '#3788d8'
    },

    /**
     * ドラッグ＆ドロップ
     */
    handleEventDrop: function (info) {
      // alert(`イベントが ${info.event.start.toISOString()} に移動しました`)
      // サーバーやストアに新しいイベント情報を保存する処理を追加できます
      console.log('新しいイベントデータ:', {
        id: info.event.id,
        title: info.event.title,
        start: info.event.start.toISOString()
      })
    },
    /**
     * イベントクリック
     */
    handleEventClick: function (arg) {
      arg.jsEvent.preventDefault() // デフォルトのリンク動作を無効化
      if (arg.event.url) {
        setTimeout(() => {
          window.open(arg.event.url, '_blank') // URLを別タブで開く
        })
      }
    },
    /**
     * 日付欄クリック（※”日”表示字のみ）
     */
    handleDateClick: function (arg) {
      if (arg.view.type === 'timeGridDay') {
        // alert('date click! ' + arg.dateStr)
        this.showEventDialog = true
        this.createEvent(arg.dateStr)
      }
    },
    createEvent: function (val) {
      // 日時
      var paramDate = new Date(val)
      var currentTime = new Date()

      // 日付をYYYY-MM-DD形式に変換
      var formattedDate = val.slice(0, 10).replaceAll('-', '/') // YYYY-MM-DD の形式
      var formatteStartTime = null
      var formatteEndTime = null

      if (val.includes('T')) {
        // 時間情報が含まれている場合
        formatteStartTime = paramDate.toTimeString().slice(0, 5) // HH:mm の形式
        // 一時間後の取得
        paramDate.setHours(paramDate.getHours() + 1)
        formatteEndTime = paramDate.toTimeString().slice(0, 5) // HH:mm の形式
      } else {
        formatteStartTime = this.formatDateToHM(currentTime, 0)
        formatteEndTime = this.formatDateToHM(currentTime, 1)
      }
      this.event.startDate = formattedDate
      this.event.endDate = formattedDate
      this.event.startTime = formatteStartTime
      this.event.endTime = formatteEndTime
    },

    onAddEvent: function () {
      const startDT = this.event.startDate.replaceAll('/', '-') + (this.event.etartTime === '' ? '' : ('T' + this.event.startTime + ':00'))
      const endDT = this.event.endDate.replaceAll('/', '-') + (this.event.endTime === '' ? '' : ('T' + this.event.endTime + ':00'))
      // イベント追加
      this.events.push({
        start: startDT,
        end: endDT,
        title: this.event.eventTitle,
        allDay: this.event.allday
      })
      this.calendarOptions = {
        ...this.calendarOptions,
        events: this.filteredEvents()
      }
      this.showEventDialog = false
    },

    filteredEvents: function () {
      const self = this
      const w = this.events.filter((t) => {
        return self.eventFilter === null || t.title.indexOf(self.eventFilter) >= 0
      })
      return w
    },
    formatDateToYMD (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatDateToHM (currentTime, factor) {
      const hours = String(currentTime.getHours() + factor).padStart(2, '0')
      const minutes = String(currentTime.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    onDummyFunction: function () {
    }
  }
}
